import React, { useEffect, useState } from "react";
import { ScrollView, View, Text, Image, StyleSheet } from "react-native";
import { AppColors } from "../utility/AppColors";
import { AppFontStyle } from "../styles/AppFontStyle";
import { AppImages } from "../utility/AppImages";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import ImageComponent from "./ImageComponent";

const CoinView = ({ checkInData, setDisableClaim }) => {
  const deviceSize = useDeviceSize();
  const initialStreak = checkInData?.streak || 1;
  const initiallyClaimed = checkInData?.claimed || false;
  const [claimedDays, setClaimedDays] = useState({
    ...Object.fromEntries(
      [...Array(initialStreak - 1).keys()].map((i) => [i + 1, true])
    ),
    [initialStreak]: initiallyClaimed,
  });
  const hasUnclaimedRewards = !claimedDays[initialStreak];

  // Notify parent component when there are no unclaimed rewards
  useEffect(() => {
    setDisableClaim(!hasUnclaimedRewards);
  }, [hasUnclaimedRewards, setDisableClaim]);

  useEffect(() => {
    if (initiallyClaimed) {
      setClaimedDays((prev) => ({
        ...prev,
        [initialStreak]: true,
      }));
    }
  }, [initiallyClaimed, initialStreak]);

  const coinData = [
    { coins: 20, day: "Day 1" },
    { coins: 25, day: "Day 2" },
    { coins: 30, day: "Day 3" },
    { coins: 35, day: "Day 4" },
    { coins: 50, day: "Day 5" },
    { coins: 75, day: "Day 6" },
    { coins: 100, day: "Day 7" },
  ];

  return (
    <ScrollView
      horizontal={true}
      contentContainerStyle={styles.scrollContainer}
      style={styles.scrollView}
      showsHorizontalScrollIndicator={false}
      showsVerticalScrollIndicator={false}
    >
      {coinData.map((item, index) => {
        const dayNumber = index + 1;
        const isClaimed = claimedDays[dayNumber] || false;
        const isCurrentDay = dayNumber === initialStreak;
        let opacity = isClaimed ? 1 : isCurrentDay ? 1 : 0.5;
        return (
          <View key={index} style={[{ opacity }, { marginRight: 10 }]}>
            <View
              style={{
                padding:
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? 10
                    : 22,
                backgroundColor: isClaimed
                  ? "#140025"
                  : AppColors.buttonRed_DC2626,
                borderTopLeftRadius: 7,
                borderTopRightRadius: 7,
              }}
            >
              <ImageComponent
                url={AppImages.icCoinBelt}
                style={[
                  {
                    resizeMode: "contain",
                    width:
                      deviceSize === DEVICE_SIZES.SM ||
                      deviceSize === DEVICE_SIZES.XS
                        ? 50
                        : 75,
                    height: 50,
                  },
                ]}
              />
            </View>
            <View
              style={{
                backgroundColor: AppColors.black,
                borderBottomLeftRadius: 7,
                borderBottomRightRadius: 7,
                alignItems: "center",
              }}
            >
              <Text
                style={[
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? AppFontStyle.REGULAR_ANYBODY_12
                    : AppFontStyle.REGULAR_ANYBODY_24,
                  {
                    marginVertical: 5,
                    color: isClaimed
                      ? AppColors.appViolentColor_6D08C3
                      : AppColors.white,
                  },
                ]}
              >
                {isClaimed ? "CLAIMED" : `${item.coins} COINS`}
              </Text>
              <Text
                style={[
                  deviceSize === DEVICE_SIZES.XS ||
                  deviceSize === DEVICE_SIZES.SM
                    ? AppFontStyle.MEDIUM_ANYBODY_10
                    : AppFontStyle.MEDIUM_ANYBODY_18,
                  {
                    paddingBottom: 12,
                    textDecorationLine: isClaimed ? "line-through" : null,
                  },
                ]}
              >
                Day {index + 1}
              </Text>
            </View>
          </View>
        );
      })}
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  scrollView: {
    flexDirection: "row",
  },
  scrollContainer: {
    alignItems: "center",
  },
});

export default CoinView;
